// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 429) return "express-bottom-menu.js";
	if (chunkId === 269) return "ts-exif-parser.js";
	if (chunkId === 976) return "express-maps-menus.js";
	if (chunkId === 456) return "express-web-vitals.js";
	if (chunkId === 556) return "express-text-menus.js";
	if (chunkId === 981) return "express-photo-menus.js";
	// return url for filenames based on template
	return undefined;
};